import { createSelector, createFeatureSelector } from '@ngrx/store';
import { MarketPlaceState } from '../reducers/marketplace.reducer';

export const selectMarketPlaceState =
  createFeatureSelector<MarketPlaceState>('marketplace');

export const selectMarketPlaceData = createSelector(
  selectMarketPlaceState,
  (state: MarketPlaceState) => {
    return state.assets;
  },
);

export const selectCurrentAsset = createSelector(
  selectMarketPlaceState,
  (state: MarketPlaceState) => state.currentAsset,
);

export const selectMarketPlaceError = createSelector(
  selectMarketPlaceState,
  (state: MarketPlaceState) => state.error,
);

export const selectAssetByIdFactory = (selectedAssetId: { id: string }) =>
  createSelector(selectMarketPlaceState, (state: MarketPlaceState) =>
    state.assets.find((asset) => asset.id === selectedAssetId.id),
  );

export const selectBuyingState = createSelector(
  selectMarketPlaceState,
  (state: MarketPlaceState) => state.buying,
);

export const selectBuyOfferError = createSelector(
  selectMarketPlaceState,
  (state: MarketPlaceState) => state.buyOfferError,
);

export const selectMarketplaceLoadingState = createSelector(
  selectMarketPlaceState,
  (state: MarketPlaceState) => state.loading,
);

export const selectOrders = createSelector(
  selectMarketPlaceState,
  (state: MarketPlaceState) => state.orders,
);
